/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const OptionsInputDataParser = /* #__PURE__ */ parsers.object([
    [
        'key',
        /* #__PURE__ */ parsers.exactly('allow_override', 'delete_empty_directories', 'remove_leading_directories'),
    ],
    ['value', codecBoolean],
]);
export class OptionsInputData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return OptionsInputDataParser.decode(input).map(res => new OptionsInputData(res));
    }
    static unsafeDecode(input) {
        return OptionsInputData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return OptionsInputDataParser.encode(data);
    }
    static schema() {
        return OptionsInputDataParser.schema();
    }
}
